<template>
  <v-container class="mx-auto pl-6" fluid>
    <v-row v-if="headers">
      <v-col cols="2" class="break-point-custom-rpa first-v-col-rpa pt-0 px-0">
        <base-material-card color="primary" icon="mdi-folder-network-outline" inline class="ml-0">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">Diretórios</div>
          </template>
          <v-treeview
            :items="directoryOrganization"
            :active.sync="active"
            :open.sync="openTabs"
            :open-all="true"
            activatable
            item-key="id"
            open-on-click
            :multiple-active="false"
            :transition="true"
          >
            <template v-slot:prepend="{ open }">
              <v-icon>
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
          </v-treeview>
        </base-material-card>
      </v-col>
      <v-col cols="10" class="break-point-custom-rpa px-0 py-0">
        <base-material-card color="primary" icon="mdi-file-outline" inline class="ml-2 px-5 py-3">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Arquivos
              <template v-if="getDateFormattedCard">
                <v-icon color="primary" class="mb-1 mx-1">mdi-arrow-right-thick</v-icon>
                {{ getDateFormattedCard }}
              </template>
            </div>
          </template>
          <general-progress-bars class="mt-11" :items="downloadProgressData" prefixText="Baixando Arquivo" />
          <template v-if="getDateFormattedCard">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto"
              label="Procurar"
              hide-details
              single-line
              style="max-width: 100%"
            />
            <v-divider class="mt-10" />
          </template>
          <v-data-table
            class="mb-0 style-table-arquivos-rpa"
            :headers="headers"
            :items="getItemsFromSelectedPath"
            :search.sync="search"
            :headerProps="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            sort-by="timestamp"
            :sort-desc="true"
            no-data-text="Selecione um diretório ao lado para visualizar os arquivos."
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="920"
            :hide-default-footer="loading || !getItemsFromSelectedPath"
            :hide-default-header="loading || !getItemsFromSelectedPath"
            :loading="loading"
            loading-text="Carregando arquivos ..."
          >
            <template v-slot:[`item.basename`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" class="text-truncate-column" v-on="on">
                    <a href="javascript:void(0)" @click="download(item.path, item.basename)">{{ item.basename }}</a>
                    <v-btn
                      v-if="downloadProgressData[item.path] !== undefined ? true : false"
                      color="gray"
                      class="mb-2 ml-2"
                      fab
                      icon
                      height="18"
                      width="18"
                      :loading="true"
                    />
                  </div>
                </template>
                <span>Baixar Arquivo -> {{ item.basename }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.size`]="{ item }">
              {{ item.size | bytesToSize }}
            </template>
            <template v-slot:[`item.enviado_por`]="{ item }">
              {{ item.enviado_por }}
            </template>
            <template v-slot:[`item.timestamp`]="{ item }">
              {{ item.timestamp | timeStampToDate }}
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
    <v-card v-else class="pa-3 pt-0 v-card--material" color="#F7FAFA">
      <v-row align="center" justify="center" style="background-color: #f7fafa">
        <v-col cols="auto" align="left" color="red">
          <v-img src="@/assets/robot.svg" max-width="200" max-height="300" />
        </v-col>
        <v-col cols="auto" align="center" class="justify-center">
          <label class="label-not-found-rpa">Nenhum arquivo enviado até o momento ...</label>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    components: {
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
    },
    mixins: [DateFormatterMixins],

    data: () => ({
      active: [],
      openTabs: [],
      directoryOrganization: [],
      items: [],
      search: '',
      headers: [
        {
          text: 'Nome do Arquivo',
          value: 'basename'
        },
        {
          text: 'Tamanho',
          value: 'size'
        },
        {
          text: 'Enviado por',
          value: 'enviado_por'
        },
        {
          text: 'Enviado em',
          value: 'timestamp'
        }
      ],
      loading: true,
      downloadProgressData: {}
    }),

    computed: {
      getItemsFromSelectedPath() {
        if (!this.active) return undefined;

        let key = this.active[0];
        return this.items[key];
      },

      getDateFormattedCard() {
        return this.getItemsFromSelectedPath ? this.formatMonth(this.getItemsFromSelectedPath[0].filename.substring(0, 10)) : '';
      }
    },

    created() {
      this.getAllItems();
    },

    methods: {
      getAllItems() {
        return ArquivosService.getRpaFilesUploadedToday()
          .then((response) => {
            if (response.data.dailyFiles.length != 0) {
              this.mountItemsDirectory(Object.keys(response.data.dailyFiles));
              this.items = response.data.dailyFiles;
            } else {
              this.headers = undefined;
            }
            this.loading = false;
          })
          .catch((err) => {
            console.error('Erro ao recuperar arquivos do RPA: ', err);
            this.$toast.error('Erro ao recuperar arquivos do RPA.', '', { position: 'topRight' });
          });
      },

      mountItemsDirectory(arrMonthsYears) {
        let arrayObj = [];
        let anosMapeados = [];
        let maiorMesAno = '';

        arrMonthsYears.forEach((anoMes) => {
          if (anoMes > maiorMesAno) maiorMesAno = anoMes;

          let ano = anoMes.substring(0, 4);
          let mes = anoMes.substring(5);

          if (anosMapeados.indexOf(ano) === -1) {
            arrayObj.push({
              name: ano,
              id: ano,
              children: [{ id: `${ano}-${mes}`, name: mes }]
            });
            anosMapeados.push(ano);
          } else {
            arrayObj.forEach((obj, index) => {
              if (obj.name == ano) {
                arrayObj[index].children.push({ id: `${ano}-${mes}`, name: mes });
                arrayObj[index].children.sort((a, b) => a.name.localeCompare(b.name));
              }
            });
          }
        });
        this.directoryOrganization = arrayObj;
        /* Seta a tab do ultimo registro cadastrado no S3 como aberta  (open) */
        this.active = [maiorMesAno];
        this.openTabs = [maiorMesAno.substring(0, 4)];
        this.$forceUpdate();
      },

      download(path, basename) {
        const id = basename;

        this.$set(this.downloadProgressData, id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

        ArquivosService.baixarRpaFileS3(path, basename, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;
            this.$set(this.downloadProgressData, id, { progress, isComputable, id });
          }
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', basename);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.$toast.error('Erro ao baixar arquivs enviado pelo RPA.', '', { position: 'topRight' });
            console.error(error);
          })
          .finally(() => {
            this.$delete(this.downloadProgressData, id);
          });
      }
    },

    watch: {
      openTabs(newArrayValues) {
        if (!newArrayValues.length) return;
        if (newArrayValues.length > 1) this.openTabs = [newArrayValues[newArrayValues.length - 1]];
      }
    }
  };
</script>

<style>
  .first-v-col-rpa {
    min-width: 195px !important;
  }
  .style-table-arquivos-rpa table thead tr th {
    font-weight: 400;
    font-size: 14px;
    height: 33px;
  }

  .style-table-arquivos-rpa table tbody tr td {
    word-wrap: break-word;
    max-width: 240px;
    font-size: 12.5px;
    padding: 0px 8px !important;
    height: 45px;
  }

  @media screen and (max-width: 826px) {
    .break-point-custom-rpa {
      max-width: 100% !important;
      -ms-flex: 0 0 100% !important;
      flex: 0 0 100% !important;
      margin-left: 0px !important;
    }
  }

  @media screen and (max-width: 920px) {
    .style-table-arquivos-rpa table tbody tr td {
      max-width: 100% !important;
    }
  }

  .label-not-found-rpa {
    font-size: 21px;
    color: rgba(0, 0, 0, 0.3);
    line-height: 1;
    min-height: 8px;
  }
</style>